import React from "react";
import CrudPage from "@/components/common/CrudPage";
import { Microscope } from "lucide-react";
import { useApp } from "@/contexts/AppContext";
import { useAIOutputs } from "@/hooks/useAIOutputs";
import AICategoryPanel from "@/components/ai/AICategoryPanel";

function ForensicsAIPanel() {
  const { currentCase } = useApp();
  const { outputs, addOutput } = useAIOutputs(currentCase?.id);
  return (
    <AICategoryPanel
      caseId={currentCase?.id} promptKey="expert_analysis" titleEl="Ανάλυση Πραγματογνωμοσύνης (AI)"
      outputs={outputs} onGenerated={addOutput}
    />
  );
}

const FIELDS = [
  { k: "name", label: "Όνομα πραγματογνώμονα" },
  { k: "field", label: "Ειδικότητα" },
  { k: "report_title", label: "Τίτλος έκθεσης" },
  { k: "key_conclusions", label: "Βασικά συμπεράσματα", type: "textarea", rows: 3 },
  { k: "weaknesses", label: "Αδυναμίες", type: "textarea", rows: 3 },
  { k: "assumptions", label: "Υποθέσεις", type: "textarea", rows: 2 },
  { k: "questions", label: "Ερωτήσεις αντεξέτασης", type: "textarea", rows: 3 },
  { k: "simple_explanation", label: "Επεξήγηση σε απλή γλώσσα", type: "textarea", rows: 3 },
  { k: "linked_documents", label: "Συνδεόμενα έγγραφα" },
];

export default function Forensics() {
  return (
    <CrudPage
      slug="experts" title="Πραγματογνωμοσύνες"
      subtitle="Διαχείριση πραγματογνωμόνων, εκθέσεων, αδυναμιών και ερωτήσεων αντεξέτασης."
      emptyIcon={Microscope} fields={FIELDS}
      listColumns={{
        title: it => it.name,
        subtitle: it => `${it.field || "—"} — ${it.report_title || ""}`,
        body: it => it.key_conclusions,
      }}
      badges={{}}
      extra={<ForensicsAIPanel/>}
    />
  );
}
